import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        container: {
            width: '100%',
            display: 'flex',
            gap: '20px',
            alignItems: 'start',
            justifyContent: 'space-between',
            '& .button-1': {
                borderRadius: '0px',
                padding: '5px 20px'
            },
        },
        main: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            padding: '0px 0px 0px 8px',
        },
        actions: {
            display: 'flex',
            alignItems: 'center',
            '& .MuiIconButton-root:not(:last-child)': {
                width: '40px',
                height: '40px',
                fontSize: '30px',
                '& .MuiSvgIcon-root': {
                    fontSize: '1em',
                    width: '1em',
                    height: '1em'
                }
            }
        },
        title: {
            fontWeight: 'bold',
            fontSize: '16px'
        },
        containerDetail: {
            flex: '0 1 600px',
            display: 'flex',
            alignItems: 'start',
            flexWrap: 'wrap',
        },
        detail: {
            fontSize: '14px',
            whiteSpace: 'pre-line'
        },
        keyValue: {
            position: 'relative',
            //flex: '1 0 150px',
            '& .detail-value': {
                '&.MuiTypography-root': {
                    fontWeight: 'bold',
                    color: colors.black,
                    fontSize: '14px'
                },
            },
            '& .detail-caption': {
                '&.MuiTypography-root': {
                    fontSize: '12px',
                    color: colors.black,
                },
            }
        },
        withExecution:{
            flex: '1 0 120px',
        },
        withoutExecution:{
            flex: '1 0 150px',
        },
        detailContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: 2,
            '& .button-1': {
                borderRadius: '0px',
                '&.MuiButton-root': {
                    padding: '5px 20xp'
                }
            },
        },
        accordion: ({ view }: { view: boolean }) => ({
            ...view && {
                '& .MuiAccordionSummary-content': {
                    margin: '12px 0',
                },
                '& .MuiAccordionSummary-root': {
                    alignItems: 'start',
                    gap: 1
                },
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: view ? '12px 0' : '0',
            },
            width: '100%',
            '& .MuiAccordionSummary-expandIconWrapper': {
                transition: 'none',
                marginTop: view ? '15px' : '-10px'
            },
            '& .MuiAccordionDetails-root': {
                padding: '0px 24px 24px'
            }
        }),
        borderRight: {
            '&.detail-container::after': {
                content: "''",
                width: '1px',
                height: '40px',
                background: '#000',
                position: 'absolute',
                right: 0
            }
        },
        settingButton: {
            display: 'none',
            [breakpoints.down(1200)]: {
                display: 'block',
                padding: '0px'
              },
        },
        formControl:{
            marginTop:'10px',
            minWidth:'250px',
            /* '& .MuiOutlinedInput-root': {
              padding: '9px 9px 9px 0px !important',
            },*/
            '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
                marginRight: '-30px'
            } 
        },
        titleAutocomplete: {
            '& .MuiInputBase-input': {
                fontSize: '16px',
                fontWeight: 'bold',
            },
            /* '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: 'none' 
                }
            } */
        },
    }
}

export { useStyles }
